<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        应急运力企业<span class="title-msg"
          >总企业数：{{ titleMsgObj.comparyInfoNum }}；应急企业数：{{
            titleMsgObj.emergencyCompanyNum
          }}；邀请待确认企业数：{{ titleMsgObj.confirmCompanyNum }}</span
        >
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="新增对接"
            icon="e6-icon-add_line"
            @click="$router.push('emergencyManageCompanyAdd')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.comparyIdList" class="form-item_2">
            <el-select
              v-model="slotForms.forms.comparyIdList"
              multiple
              filterable
              collapse-tags
              reserve-keyword
              placeholder="企业名称"
              :loading="loading"
            >
              <el-option
                v-for="item in comparyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.regisArea">
            <e6-city
              ref="e6City"
              :format="$GLOBAL_CONFIG.e6City.format"
              :placeholder="$GLOBAL_CONFIG.e6City.placeholder"
              :label="slotForms.forms.regisArea"
              class="e6-city"
              @selected="citySelect"
              :fixed-bin="$GLOBAL_CONFIG.e6City.bin"
            ></e6-city>
          </el-form-item>
          <el-form-item prop="forms.invitationStatusList">
            <el-select
              v-model="slotForms.forms.invitationStatusList"
              placeholder="企业受邀状态"
              clearable
              multiple
              collapse-tags
            >
              <el-option label="待确认" :value="1"></el-option>
              <el-option label="同意" :value="2"></el-option>
              <el-option label="拒绝" :value="3"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格tab -->
    <section
      class="g-table-tab-section table-tab-section fixed-view"
      v-show="false"
    >
      <e6-flank-fix>
        <template slot="fixRight">
          <i
            class="flank-fix__item e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
          ></i>
        </template>
      </e6-flank-fix>
    </section>
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <el-table-column
          label="序号"
          align="center"
          width="60"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          label="企业名称"
          prop="companyName"
          align="center"
          min-width="130"
          fixed="left"
        >
        </el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          align="center"
          :show-overflow-tooltip="true"
          min-width="130"
          :prop="item.name"
          :label="item.title"
        >
        </el-table-column>
        <el-table-column label="应急车辆" prop="emergencyVehicleNum">
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.emergencyVehicleNum > 0"
              :to="{
                path: '/emergencyManageVehicleList',
                query: { vehicleIds: scope.row.vehicleIds },
              }"
              style="color: #0000ff"
            >
              {{ scope.row.emergencyVehicleNum }}
            </router-link>
            <span v-else>{{ scope.row.emergencyVehicleNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="应急司机" prop="emergencyDriverNum">
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.emergencyDriverNum > 0"
              :to="{
                path: '/emergencyManageDriverList',
                query: { driverIds: scope.row.driverIds },
              }"
              style="color: #0000ff"
            >
              {{ scope.row.emergencyDriverNum }}
            </router-link>
            <span v-else>{{ scope.row.emergencyDriverNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130" align="center">
          <template slot-scope="{ row }">
            <span
              class="operate"
              v-if="row.invitationStatus === 2"
              @click="handleCancel(row, 1)"
              >取消应急企业</span
            >
            <span
              class="operate"
              v-if="row.invitationStatus === 3"
              @click="handleCancel(row, 3)"
              >再次邀请</span
            >
            <span
              class="operate"
              v-if="row.invitationStatus === 3"
              @click="handleCancel(row, 2)"
              >删除</span
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
// Api
import {
  FetchGetTableColumnSettings,
  FetchSaveUserTableColumnSettings,
} from "_private/api/public.js";

import {
  FetchFindByPage,
  FetchEmergencyCompary,
} from "@/api/base/emergencyCompary";

import {
  getEmergencyCompanyAndOtherNum,
  changeStatus,
} from "@/api/emergencyManage/company";

// Components
import e6City from "e6city";

// Vuex
import { mapGetters, mapActions } from "vuex";

// Mixins
import resizeListener from "_private/mixins/resizeListener";
import operationManage from "_private/mixins/operationManage";

// Private Methods
import { mergeFormExtend } from "_private/utils/merge";

export default {
  components: { e6City },
  mixins: [resizeListener, operationManage],
  data() {
    return {
      total: 0,
      isSearch: false,
      curPage: 1,
      pageSize: 20,
      vehicleTreeList: [],
      comparyList: [],
      formExtend: {
        forms: {
          invitationStatusList: "",
          comparyIdList: [],
          comparyName: "",
          provinceName: $GLOBAL_CONFIG.e6City.provinceName,
          cityName: $GLOBAL_CONFIG.e6City.cityName,
          countyName: "",
        },
        extends: [],
      },
      formsExtend: [],
      tableData: [],
      columSetVisible: false,
      showTableCols: [],
      hideTableCols: [],
      copyShowTableCols: [],
      copyHideTableCols: [],
      localShowTableCols: [],
      multipleSelection: [],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      idList: [],
      errMess: "",
      loading: false,
      isFirstLoad: true,
      //导出URL
      exportUrl: "/base/store/exportStoreInfo?",
      titleMsgObj: {},
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"]),
    ids() {
      let ids = this.multipleSelection.map((item) => {
        return item.id;
      });
      return ids.length < 1 ? "" : ids.join(",");
    },
    columnStr() {
      let columnStr = this.copyShowTableCols.map((item) => {
        return item.name;
      });
      return columnStr.length < 1 ? "" : columnStr.join(",");
    },
  },
  created() {
    this.FetchGetTableColumnSettings({
      moduleId: this.moduleId,
      userId: this.userId,
    });
    //初始化应急企业列表下拉
    this.getCompanyAndOtherNum();
    this.initComparyName();
    this.setSearchFormIsOpenAct();
  },
  mounted() {
    let comparyName = this.$route.query.comparyName;
    if (comparyName) {
      this.formExtend.forms.comparyName = comparyName;
    }
    this.FetchFindByPage(this.mergeObj());
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 获取title详情信息
    async getCompanyAndOtherNum() {
      let { code, result } = await getEmergencyCompanyAndOtherNum();
      if (code === 1 && result) {
        this.titleMsgObj = result;
      }
    },
    //初始化应急企业列表下拉
    initComparyName() {
      FetchEmergencyCompary()
        .then((response) => {
          if (response.result && Array.isArray(response.result)) {
            this.comparyList = response.result;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    citySelect(res) {
      if (res.province.name == "澳门") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "香港") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "台湾省") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.city.name;
        this.formExtend.forms.countyName = res.district.name;
      }
    },
    // 获取表格数据
    FetchFindByPage(response) {
      this.loading = true;
      FetchFindByPage(response)
        .then((response) => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            this.tableData = response.result.data;
            this.total = response.result.totalRecords;
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    // 获取表格列列表
    FetchGetTableColumnSettings(data) {
      FetchGetTableColumnSettings(data)
        .then((response) => {
          let data = response;
          let showTableCols = [];
          let hideTableCols = [];
          if (data && data.result && Array.isArray(data.result)) {
            data.result.forEach((item) => {
              if (item.name == "companyName") {
                this.$set(item, "show", false);
              }
              if (item.show) {
                showTableCols.push(item);
              } else {
                hideTableCols.push(item);
              }
            });
          }
          this.showTableCols = showTableCols;
          this.hideTableCols = hideTableCols;
          this.copyShowTableCols = showTableCols;
          this.copyHideTableCols = hideTableCols;
          this.localShowTableCols = showTableCols;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 修改表格列列表
    FetchSaveUserTableColumnSettings(data) {
      FetchSaveUserTableColumnSettings(data)
        .then((response) => {
          let type = response.code === 1 ? "success" : "error";
          let message = response.message;
          this.$message({
            showClose: true,
            message: message,
            type: type,
            duration: 2000,
            onClose: () => {
              if (type === "success") {
                this.FetchGetTableColumnSettings({
                  moduleId: this.moduleId,
                  userId: this.userId,
                });
              }
            },
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      // let vehicleIdList;
      // if (this.isFirstLoad) {
      //     vehicleIdList = this.idList;
      //     this.isFirstLoad = false;
      // } else {
      //     vehicleIdList = this.getVehicleIdListParam();
      // }
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize,
        },
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    // 重置
    handleResetForm() {
      this.$refs.e6City.cityInputValue = "河南省郑州市";
      this.formExtend.forms.provinceName = "河南省";
      this.formExtend.forms.cityName = "郑州市";
      this.formExtend.forms.countyName = "";
    },
    // 选择表格列
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },

    // 取消表格列设置
    handleSetColumnCancel() {
      this.copyShowTableCols = this.showTableCols;
      this.copyHideTableCols = this.hideTableCols;
    },
    // 确认表格列设置
    handleSetColumnSubmit() {
      this.FetchSaveUserTableColumnSettings({
        moduleId: this.moduleId,
        userId: this.userId,
        columnStr: this.columnStr,
      });
    },
    //获取选中区位id
    getVehicleIdListParam() {
      let selected = this.$refs.vehicleTreeSelect.getSelectValues();
      selected = selected.map((item) => {
        return item.id;
      });
      return selected;
    },

    handleExportClick() {
      let vehicleIdList;
      if (this.isFirstLoad) {
        vehicleIdList = this.idList;
        this.isFirstLoad = false;
      } else {
        vehicleIdList = this.getVehicleIdListParam();
      }
      let param = "";
      param += "&comparyName=" + this.formExtend.forms.comparyName;
      param += "&provinceName=" + this.formExtend.forms.provinceName;
      param += "&cityName=" + this.formExtend.forms.cityName;
      param += "&countyName=" + this.formExtend.forms.countyName;
      param += "&vehicleIdList=" + vehicleIdList;
      document.location.href = this.exportUrl + param;
    },

    // 取消应急企业
    handleCancel(row, state) {
      let msg = "";
      state === 1 && (msg = "取消");
      state === 2 && (msg = "删除");
      state === 3 && (msg = "再次邀请");
      this.$confirm(
        `确定${msg}‘企业--${row.companyName}’吗？`,
        `${msg}应急企业`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.companyOperate(row, state);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async companyOperate(row, state) {
      try {
        this.loading = true;
        let params = {
          companyId: row.companyId,
          emergencyId: row.id,
          operateId: state,
        };
        let { code, result } = await changeStatus(params);
        if (code === 1) {
          this.FetchFindByPage(this.mergeObj());
          this.$message.success(result);
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;

  // 标题详情企业数据
  .title-msg {
    font-size: 14px;
    padding-left: 20px;
  }
}

.table-section {
  height: 200px;

  .operate {
    cursor: pointer;
    color: #2196f3;
    margin: 0 5px;
  }
}

.pagination-section {
  padding: 10px 0;
}

.form-item_2 {
  width: 200px;

  /deep/ .el-form-item--mini .el-form-item__content {
    width: 200px;
  }

  /deep/ .el-select {
    width: 200px;

    .el-select__tags {
      max-width: 195px !important;
    }

    .el-select__tags-text {
      display: inline-block;
      max-width: 90px;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: middle;
    }
  }
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
